const prefix = 'CONTROL_INFO';

export const GET_INGREDIENT_GROUPS_LOADING = `${prefix}_GET_INGREDIENT_GROUPS_LOADING`;
export const GET_INGREDIENT_GROUPS_SUCCESS = `${prefix}_GET_INGREDIENT_GROUPS_SUCCESS`;
export const GET_INGREDIENT_GROUPS_ERROR = `${prefix}_GET_INGREDIENT_GROUPS_ERROR`;

export const WRITE_INGREDIENT_GROUPS_LOADING = `${prefix}_WRITE_INGREDIENT_GROUPS_LOADING`;
export const WRITE_INGREDIENT_GROUPS_SUCCESS = `${prefix}_WRITE_INGREDIENT_GROUPS_SUCCESS`;
export const WRITE_INGREDIENT_GROUPS_ERROR = `${prefix}_WRITE_INGREDIENT_GROUPS_ERROR`;

export const DELETE_INGREDIENT_GROUP_LOADING = `${prefix}_DELETE_INGREDIENT_GROUP_LOADING`;
export const DELETE_INGREDIENT_GROUP_SUCCESS = `${prefix}_DELETE_INGREDIENT_GROUP_SUCCESS`;
export const DELETE_INGREDIENT_GROUP_ERROR = `${prefix}_DELETE_INGREDIENT_GROUP_ERROR`;

export const CLEAR_ERROR = `${prefix}_INGREDIENT_GROUP_CLEAR_ERROR`;

export const GET_INGREDIENT_SOURCES_LOADING = `${prefix}_GET_INGREDIENT_SOURCES_LOADING`;
export const GET_INGREDIENT_SOURCES_SUCCESS = `${prefix}_GET_INGREDIENT_SOURCES_SUCCESS`;
export const GET_INGREDIENT_SOURCES_ERROR = `${prefix}_GET_INGREDIENT_SOURCES_ERROR`;



// WEBPACK FOOTER //
// ./src/pages/controlinformation/state/ingredientGroup/types.js